<template>
    <div class="smart-image-popover">
        <div id="arrow" class="smart-image-popover__arrow" />
        <div class="smart-image-popover__header">
            <p class="smart-image-popover__header-title">
                <span v-if="imageList[currentIndex] && imageList[currentIndex].fig_title_code">{{ $t('imageLoader.Figure') }} {{ imageList[currentIndex].fig_title_code }}</span>
            </p>
            <PtIcon class="smart-image-popover__header-icon" icon="SolidCloseMedium" @click="$emit('close')" />
        </div>
        <PtIcon
            v-if="loading"
            class="smart-image-popover__loading"
            icon="SolidLoadingBars"
        />
        <div v-else-if="nodata" class="smart-image-popover__nodata">
            <PtIcon
                class="smart-image-popover__nodata-icon"
                icon="SolidImageNoImage"
            />
            <span class="smart-image-popover__nodata-label">{{ $t('noImage') }}</span>
        </div>
        <template v-else>
            <div class="smart-image-popover__content">
                <ul class="smart-image-popover__image" :style="`margin-left: ${-200 * (curPage - 1)}px;`">
                    <li
                        v-for="(image, index) in imageList"
                        :key="index"
                        class="smart-image-popover__image-item"
                    >
                        <!-- 图片小时，isPreview为true，避免标签溢出显示 -->
                        <image-loader-v3
                            v-bind="matchParams"
                            :showMode="'boxWithoutText'"
                            :fetchFigures="fetchFigures"
                            :figurePostprocess="fetchFiguresPostProcessor()"
                            :loadImage="() => getFigurePartText(image, labelLang)"
                            @imageLoaded="imageLoaded(index)"
                        />
                    </li>
                </ul>
            </div>
            <div class="smart-image-popover__handler">
                <div class="smart-image-popover__handler-flip">
                    <PtIcon
                        :class="{
                            'smart-image-popover__handler-icon': true,
                            'smart-image-popover__handler-icon--disabled': prevDisabled
                        }"
                        icon="SolidArrowLeft"
                        @click="onChangePage('prev', prevDisabled)"
                    />
                    <span class="smart-image-popover__handler-flip-label">{{ curPage }}/{{ imageList.length }}</span>
                    <PtIcon
                        :class="{
                            'smart-image-popover__handler-icon': true,
                            'smart-image-popover__handler-icon--disabled': nextDisabled
                        }"
                        icon="SolidArrowRight"
                        @click="onChangePage('next', nextDisabled)"
                    />
                </div>
                <PtIcon class="smart-image-popover__handler-icon" icon="SolidResizeFullScreen" @click="onShowPanel " />
            </div>
        </template>
    </div>
</template>

<script>
import ImageLoaderV3 from 'library-@/components/image-loader-v3';
import { formatePdfImageDataV2 } from '../../utils/pdfImageFormate';
import { figurePostprocess, getFigurePartText } from 'library-@/components/image-panel-v3/src/smart-image-adjust-layer/ChangeService.ts';
import { fetchFigures } from '../../utils/figure';
import { getTextRelatedImgApi, getSignImageApi } from 'library-@/apis/core_basic_api/image';
import smartImageService from '@/services/smartImageService';
import { Icon } from 'patsnap-biz';
import _ from 'lodash';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';
import '@patsnap-ui/icon/assets/solid/ResizeFullScreen.svg';
import '@patsnap-ui/icon/assets/solid/ImageNoImage.svg';

export default {
    name: 'SmartImagePopover',
    components: {
        PtIcon: Icon,
        ImageLoaderV3,
    },
    props: {
        labelName: {
            type: String,
            required: true,
        },
        code: {
            type: String,
            required: true,
        },
        labelId: {
            type: String,
            required: true,
        },
        labelLang: {
            type: String,
            default: undefined,
        },
        patentId: {
            type: String,
            required: true,
        },
        isCompare: {
            type: Boolean,
            default: false,
        },
        side: {
            type: String,
        },
        tab: {
            type: String,
        },
    },
    data() {
        return {
            loading: true,
            smartImageService,
            figureTextVisible: true,
            curPage: 1,
            imageList: [],
            imageLoadedList: [],
            imagePanelData: {
                index: 0,
                list: [],
                total: 0,
                type: 'image',
            },
            nodata: false,
            imageLang: null,
        };
    },
    computed: {
        prevDisabled() {
            return this.curPage === 1;
        },
        nextDisabled() {
            return this.curPage === this.imageList.length;
        },
        enableVerticalFigText() {
            return this.imageLang === 'CN';
        },
        currentIndex() {
            return this.curPage - 1;
        },
        matchParams() {
            const params = {};
            if (this.tab === 'clms') {
                params.matchLabelText = this.labelName;
            } else {
                params.focusedId = this.labelId;
                params.matchLabelId = this.labelId;
            }
            return params;
        },
    },
    async created() {
        let params;
        if (this.isCompare) {
            params = {
                patentId: this.patentId,
                view: 'compare',
                side: this.side,
            };
        } else {
            params = {
                patentId: this.patentId,
                view: 'common',
            };
        }
        this.smartImageService.setCurrentPatentId(params);
        await this.initRelatedImage();
        this.loading = false;
    },
    methods: {
        fetchFigures,
        figurePostprocess,
        getFigurePartText,
        onChangePage(flip, disabled) {
            if (disabled) return;
            flip === 'prev' ? this.curPage -= 1 : this.curPage += 1;
        },
        imageLoaded(index) {
            this.imageLoadedList.push(index);
        },
        fetchFiguresPostProcessor() {
            const self = this;
            return function() {
                let figures = self.figurePostprocess.apply(self, [...arguments]);
                return figures;
            };
        },
        async initRelatedImage() {
            const params = {
                text: this.labelName,
                code: this.code,
                patent_id: this.patentId,
            };
            if (this.labelLang) {
                params.lang = this.labelLang;
            }
            if (this.tab === 'clms') params.tab = this.tab;
            let imageList = await getTextRelatedImgApi(params);
            if (!imageList.length) {
                this.nodata = true;
                return;
            }
            this.imageLang = _.get(imageList, '0.lang');
            const batchParams = [];
            imageList.forEach(item => {
                const imageId = item.image_id;
                const cacheData = this.smartImageService.getImageCache({
                    imageId,
                    patentId: this.patentId,
                });
                if (!cacheData) {
                    const url = item.url || item.storage_path || item.fulltext_image_url;
                    if (url.includes('https://')) {
                        const formatImageData = formatePdfImageDataV2(item);
                        this.smartImageService.setImageCache({
                            patentId: this.patentId,
                            imageId,
                            data: Object.assign({}, item, formatImageData),
                        });
                    } else {
                        batchParams.push({
                            patent_id: this.patentId,
                            image_id: imageId,
                        });
                    }
                }
            });

            const signedList = batchParams.length ? await getSignImageApi(batchParams) : [];
            signedList.forEach(item => {
                const matchItem = imageList.find(image => image.image_id === item.image_id);
                Object.assign(matchItem, item || {});
                const formatImageData = formatePdfImageDataV2(matchItem);
                this.smartImageService.setImageCache({
                    patentId: this.patentId,
                    imageId: item.image_id,
                    data: Object.assign({}, matchItem, formatImageData),
                });
            });

            this.imageList = imageList.map(item => {
                const cacheData = this.smartImageService.getImageCache({
                    imageId: item.image_id,
                    patentId: this.patentId,
                });
                return getFigurePartText(cacheData || item, this.labelLang);
            });
            this.imagePanelData.total = this.imageList.length;
            this.imagePanelData.list = this.imageList;
        },
        onShowPanel() {
            this.imagePanelData.index = this.currentIndex;
            this.$emit('showSmartPanel', {
                enableVerticalFigText: this.enableVerticalFigText,
                figureTextVisible: this.figureTextVisible,
                fetchFigures: this.fetchFigures,
                imageData: this.imagePanelData,
                imagePanelShow: true,
                showFigures: true,
                figureTextFocusedId: this.labelId,
                figureTextMatchLabel: this.labelId ? '' : this.labelName,
            });
        },
        getDefaultTranslate(item) {
            const rollTimes = _.get(item, 'figure.image_direction', 0);
            return {
                rollTimes: _.isNumber(rollTimes) ? rollTimes : +rollTimes,
                scale: 1,
                position: [0, 0],
            };
        },
    },
};
</script>

<style lang="scss">
.smart-image-popover {
    width: 218px;
    min-height: 276px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.08), 0px 2px 6px 0px rgba(0,0,0,0.08);
    border: 1px solid #DFE1E6;
    border-radius: 4px;
    z-index: 98;
    padding: 8px;
    /* 箭头样式 */
    &__arrow {
        height: 12px;
        width: 20px;
        overflow: hidden;
        position: absolute;
        top: -12px;
        left: 20px;
        &::before {
            position: absolute;
            content: '';
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.08), 0px 2px 6px 0px rgba(0,0,0,0.08);
            height: 12px;
            width: 12px;
            background: #fff;
            border: 1px solid #DFE1E6;
            transform: rotate(45deg);
            top: 7px;
            left: 2px;
        }
    }

    &__loading {
        position: absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        font-size: 24px;
        color: $fill-normal;
    }

    &__nodata {
        position: absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        &-icon {
            color: #B3BAC5;
            font-size: 48px;
            margin-bottom: 0;
        }
        &-label {
            margin-top: 8px;
            line-height: 24px;
            color: $text-hint;
        }
    }

    &__header {
        line-height: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        &-title {
            flex: 1;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
        }
        &-icon {
            font-size: 24px;
            margin-bottom: 0;
            flex-shrink: 0;
            cursor: pointer;
            color: $fill-normal;
            &:hover {
                background: #F0F1F3;
                border-radius: 2px;
            }
        }
    }
    &__content {
        margin-top: 4px;
        height: 200px;
        width: 200px;
        // background: #495973;
        overflow: hidden;
    }
    &__image {
        height: 100%;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        transition-property: margin-left;
        transition-duration: 0.5s;
        transition-timing-function: ease;
        &-item {
            height: 100%;
            width: 100%;
            padding: 8px;
            position: relative;
            flex-shrink: 0;
            overflow: hidden;
        }
        &-item-mask {
            position: absolute;
            right: 0;
            left: 0;
            bottom: 0;
            top: 0;
            margin: auto;
        }
    }
    &__handler {
        margin-top: 4px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-icon {
            font-size: 24px;
            color: $fill-normal;
            margin-bottom: 0;
            cursor: pointer;
            &:hover {
                background: #F0F1F3;
                border-radius: 2px;
            }
        }
        &-icon--disabled {
            cursor: not-allowed;
            color: $text-disable;
        }

        &-flip {
            display: flex;
            align-items: center;
            user-select:none;
            &-label {
                display: inline-block;
                line-height: 24px;
                margin: 0 4px;
                color: $text-hint;
            }
        }
    }
}
.smart-image-popover[data-popper-placement^="top"] {
    .smart-image-popover__arrow {
        top: auto;
        bottom: -12px;
        &::before {
            top: auto;
            bottom: 7px;
        }
    }
}
</style>
